<template>
  <div class="nav">
    <span class="aside">
      <template v-if="loggedIn">
        <router-link to="/settings">Settings</router-link>
        |
        <router-link to="/users">Users</router-link>
        |
        <router-link to="/lanes">Lanes</router-link>
        |
        <template v-if="isPremium">
          <router-link to="/rules">Rules</router-link>
          |
          <router-link to="/report">Bits Report</router-link>
          |
          <router-link to="/giftsubs">Gift Subs</router-link>
          |
          <router-link to="/mails">Mails</router-link>
          |
        </template>
        <router-link to="/submissions">Submissions</router-link>
        |
        <router-link to="/queue">Queue</router-link>
      </template>
    </span>

    <span class="aside">
      <a v-if="!loggedIn" :href="authUrl">Log In</a>
      <template v-else>
        <template v-if="!channel.active">
          ⚠️
          <router-link to="/settings" class="attention">Channel Inactive</router-link>
          |
        </template>
        <template v-if="numPendingActions > 0">
          🔔
          <router-link to="/action-center" class="attention">{{ numPendingActions }} Pending</router-link>
          |
        </template>
        <a href="#" @click.prevent="logout()">Log Out</a>
        |
        <strong @click="butts()">{{ account.name }}</strong>
      </template>
    </span>
  </div>
</template>

<script>
import firebase from 'firebase'
import { mapState, mapGetters } from 'vuex'
import axios from 'axios'
import DeckHelper from '../mixins/DeckHelper'
import ApiHelper from '../mixins/ApiHelper'
import { DECK_STATUS } from '../constants'
import config from '../config'

export default {
  name: 'NavMenu',
  mixins: [DeckHelper, ApiHelper],

  data () {
    return {
      authUrl: `https://id.twitch.tv/oauth2/authorize?client_id=${config.twitch.clientId}&redirect_uri=${config.twitch.redirectUri}&response_type=code&scope=channel_subscriptions+channel_check_subscription+user_read+channel:read:subscriptions&force_verify=true`
    }
  },
  computed: {
    ...mapState(['account', 'submissions', 'giftSubBatches', 'channel']),
    ...mapGetters(['loggedIn', 'isPremium']),

    numPendingActions () {
      const pendingSubmissions = this.submissions
        .filter((s) => this.getStatus(s) === DECK_STATUS.PENDING)

      const pendingGiftSubBatches = this.giftSubBatches
        .filter((b) => b.status === 'pending')

      return pendingSubmissions.length + pendingGiftSubBatches.length
    }
  },

  methods: {
    async logout () {
      await firebase.auth().signOut()
      this.$store.dispatch('logout')
    },

    butts () {
      if (this.channel.id !== '63556386') {
        return
      }
      this.$store.dispatch('setChannel', '43349612')
    },

    checkAdminLogin () {
      if (!window.location.hash) {
        return
      }

      try {
        const params = new URLSearchParams(window.location.hash.slice(1))
        const token = params.get('access_token')

        // Validate token with API and log in
        // axios.get(`${config.api.url}/set-token?code=${token}`)
        token && axios.post(`${config.api.url}/login`, { token })
          .then(async ({ data }) => {
            // Log in to Firestore
            const { user } = await firebase.auth()
              .signInWithCustomToken(data.token)

            // Fetch user info from Twitch and update own profile
            // @todo Necessary?
            const [ profile ] = await axios
              .get('https://api.twitch.tv/helix/users', {
                headers: {
                  Authorization: `Bearer ${token}`
                }
              }).then(({ data }) => data.data)
            user.updateProfile({
              displayName: profile.display_name,
              photoURL: profile.profile_image_url
            })
            this.$router.push('/')
          })
          // .then(({ user }) => user.getIdTokenResult())
          // .then(({ claims }) => store.commit('setUser', claims))
      } catch (err) {
        console.error('Could not parse token', err)
      }
    },

    checkTokenGeneration () {
      if (!window.location.search) {
        return
      }

      try {
        const params = new URLSearchParams(window.location.search)
        const code = params.get('code')

        code && axios.get(`${config.api.url}/set-token?code=${code}`)
          .then(async (res) => {
            // Log in to Firestore
            const { user } = await firebase.auth()
              .signInWithCustomToken(res.headers['x-fs-token'])
            this.$router.push('/')
          })
          .catch((err) => {
            console.error(err)
          })
      } catch (err) {
        console.error('nooo', err)
      }
    }
  },

  created () {
    this.checkAdminLogin()
    this.checkTokenGeneration()
  }
}
</script>

<style scoped>
.nav {
  padding: 1em;
  background: #242529;
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

a {
  color: white;
}

.attention {
  color: crimson;
}
</style>
